export default function refreshPage(){
  // https://stackoverflow.com/a/7241881/7272124
  console.log("reload");
  window.location = window.location.pathname;
}